import React from 'react';
import { Card, Button, Stack } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SUPPORTS_WITHOUT_EMAIL } from './config';

const SupportCard = () => {
  const { t } = useTranslation();

  return (
    <Card body text="white" bg="primary">
      <Card.Title className="fw-bold">{t('supportCard.header')}</Card.Title>
      <Card.Text>{t('supportCard.subHeader')}</Card.Text>

      <Stack gap={1}>
        {map(SUPPORTS_WITHOUT_EMAIL, ({ type, href, value, icon, label }) => (
          <Button
            key={value}
            variant="light"
            href={href}
            target={type === 'social' ? '_blank' : undefined}
            className="text-start"
          >
            <FontAwesomeIcon icon={icon} className="fa-fw me-2" />
            {label}
          </Button>
        ))}
      </Stack>
    </Card>
  );
};

export { SupportCard };
